module.exports = __webpack_public_path__ + "static/media/SWT_01.0e01cd02.jpeg";